import type {
  SitePageDefinition,
  SitePageKey,
  SitePageToggleMap,
} from "../types/dataTypes";

export const SITE_PAGES: SitePageDefinition[] = [
  {
    key: "events",
    label: "Events",
    path: "/events",
    description: "Upcoming and past events showcase",
  },
  {
    key: "karmatek",
    label: "Karmatek",
    path: "/karmatek",
    description: "Karmatek flagship experience",
  },
  {
    key: "gallery",
    label: "Gallery",
    path: "/gallery",
    description: "Community gallery highlights",
  },
  {
    key: "faq",
    label: "FAQs",
    path: "/faq",
    description: "Frequently asked questions",
  },
  {
    key: "about",
    label: "About Us",
    path: "/about-us",
    description: "Team and mission",
  },
  {
    key: "contact",
    label: "Contact Us",
    path: "/contact",
    description: "Contact and support details",
  },
];

export const SITE_PAGE_DEFAULTS: SitePageToggleMap = SITE_PAGES.reduce(
  (acc, page) => {
    acc[page.key] = true;
    return acc;
  },
  {} as SitePageToggleMap
);

export const SITE_PAGE_MAP: Record<SitePageKey, SitePageDefinition> =
  SITE_PAGES.reduce((acc, page) => {
    acc[page.key] = page;
    return acc;
  }, {} as Record<SitePageKey, SitePageDefinition>);

export const SITE_PAGE_KEYS: SitePageKey[] = SITE_PAGES.map((page) => page.key);
